module.exports = __webpack_public_path__ + "static/dapl-1ba5d45709127f3b7baf49c7d0eb7c77.jpg";